import { Paper, Typography } from "@mui/material"
import type { FC } from "react"

import CommentsSection from "@/components/Comment/CommentsSection"
import { PermissionActionType } from "@/constants/permissions"
import type { ProductTest } from "@/graphql/codegen/graphql"
import { CommentParentTableType } from "@/graphql/codegen/graphql"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface ProductTestCommentsProps {
  productTest: ProductTest
}

export const ProductTestComments: FC<ProductTestCommentsProps> = ({ productTest }) => {
  const { hasPermissions } = usePermissionManager()
  const isReadOnly = productTest.isHistorical || !hasPermissions([PermissionActionType.TEST_TEMPLATE_MAINTENANCE])

  return (
    <Paper elevation={0} variant='outlined' className='flex flex-col gap-2 border-gray-300 p-6' data-test='comments'>
      <Typography variant='subtitle1' component='div' className='text-ml text-gray-900'>
        Comments
      </Typography>
      <CommentsSection
        referenceId={productTest.productTestId}
        type={CommentParentTableType.ProductTest}
        isReadOnly={isReadOnly}
      />
    </Paper>
  )
}
